const Validation = (values) => {
  const errors = {};
  if (values.valor < 0 || Number.isNaN(values.valor))
    errors.valor = 'Este campo é obrigatório';
  return errors;
};

export default Validation;
